module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-112.3364b1b.woff2";